import React, { useState } from 'react'
import {
    AppBar, Toolbar, Box, IconButton, Drawer,
    List, ListItem, ListItemButton, ListItemText, Divider, Typography
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CloseIcon from '@mui/icons-material/Close'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import logo from '../resources/logo.jpeg'
import * as ROUTES from '../routes'
import CurrencyIndicator from './currencyIndicator'

const NAV_LINKS = [
    { label: 'Market',      to: ROUTES.PROPERTIES  },
    { label: 'Sell',        to: ROUTES.SELL        },
    { label: 'Landscaping', to: ROUTES.LANDSCAPING },
    { label: 'About',       to: ROUTES.ABOUT       },
    { label: 'Contact',     to: ROUTES.CONTACT     },
]

export default function AppBarSmall() {
    const [open, setOpen] = useState(false)
    const location = useLocation()

    const showCurrency =
        location.pathname === ROUTES.ROOT ||
        location.pathname.startsWith(`/${ROUTES.HOME}`) ||
        location.pathname.startsWith(`/${ROUTES.PROPERTIES}`)

    return (
        <>
            <AppBar position='sticky' elevation={0}>
                <Toolbar sx={{ minHeight: 56, px: 2 }}>
                    {/* Logo */}
                    <Box
                        component={RouterLink}
                        to='/'
                        sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', flex: 1 }}
                    >
                        <img
                            src={logo}
                            alt='Choice Real Estate'
                            style={{ height: 38, width: 'auto', display: 'block' }}
                        />
                    </Box>

                    {showCurrency && <CurrencyIndicator />}
                    <IconButton
                        edge='end'
                        onClick={() => setOpen(true)}
                        sx={{ ml: 1, color: 'text.primary' }}
                        aria-label='Open menu'
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <Drawer anchor='right' open={open} onClose={() => setOpen(false)}>
                {/* Header */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                    <img src={logo} alt='Choice Real Estate' style={{ height: 32 }} />
                    <IconButton onClick={() => setOpen(false)} size='small'>
                        <CloseIcon fontSize='small' />
                    </IconButton>
                </Box>

                <List sx={{ pt: 1 }}>
                    {NAV_LINKS.map(link => {
                        const active =
                            location.pathname === `/${link.to}` ||
                            location.pathname.startsWith(`/${link.to}/`)
                        return (
                            <ListItem key={link.to} disablePadding>
                                <ListItemButton
                                    component={RouterLink}
                                    to={link.to}
                                    onClick={() => setOpen(false)}
                                    sx={{
                                        px: 3, py: 1.25,
                                        borderLeft: active ? '3px solid' : '3px solid transparent',
                                        borderColor: active ? 'primary.main' : 'transparent',
                                        backgroundColor: active ? 'primary.light' : 'transparent',
                                        '&:hover': { backgroundColor: 'primary.light' },
                                    }}
                                >
                                    <ListItemText
                                        primary={link.label}
                                        primaryTypographyProps={{
                                            fontWeight: active ? 700 : 500,
                                            color: active ? 'primary.main' : 'text.primary',
                                            fontSize: '0.9375rem',
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                        )
                    })}
                </List>

                <Divider sx={{ mt: 'auto', mx: 2 }} />
                <Box sx={{ px: 3, py: 2 }}>
                    <Typography variant='caption' color='text.secondary'>
                        © {new Date().getFullYear()} Choice Real Estate
                    </Typography>
                </Box>
            </Drawer>
        </>
    )
}
